import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatStepperScrollerDirective } from './directive/mat-stepper-scroller.directive';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { BlockHtmlCharsDirective } from './directive/block-html-chars.directive';
import { HomeownerBlockSpecialCharsDirective } from './directive/homeowner-block-html-chars.directive';

@NgModule({
  declarations: [MatStepperScrollerDirective,BlockHtmlCharsDirective,HomeownerBlockSpecialCharsDirective ],
  imports: [
    CommonModule,
    NgxMaskDirective,NgxMaskPipe,
  ],providers: [
    provideNgxMask()],
  exports:[
    MatStepperScrollerDirective,BlockHtmlCharsDirective,HomeownerBlockSpecialCharsDirective 
      ]
})
export class EbbIntegrationModule {}
